module.exports = __webpack_public_path__ + "img/home.14e06145.png";